import React, { useState } from "react";
import { useDispatch, useSelector } from "react-redux";

import { Container, Button, Row, Form, Card, Col, FloatingLabel, } from "react-bootstrap";


import RTable from "./Table"

import DatePicker from 'react-date-picker'

import { format } from "date-fns";

import { Typeahead } from "react-bootstrap-typeahead"
import { notification, warningNotification } from "../action/notificationAction";
import {
  setEnableMobileMenu
} from '../constant/constant';
import { formatCurrency } from "../constant/format";
import { filterClient, filterProjects, filterProjectsSearch } from "../constant/filterTypeahead";
import { changePayReturn, loadAllPayReturn, loadPayReturn, resetPayReturn, savePayReturnService } from "../action/returnAction";
import { loadAllPayment, loadPaymentService, resetPayment } from "../action/paymentAction";



export default function PaymentReturn({ minDate, permitted }) {

  const dispatch = useDispatch();

  const proTypeRef = React.useRef(null);

  const cltEntryTypeRef = React.useRef(null);
  const proEntryTypeRef = React.useRef(null);
  const venEntryTypeRef = React.useRef(null);


  const [show, setShow] = useState(false);

  const [errors, setErrors] = useState({});
  // eslint-disable-next-line no-unused-vars
  const [status, setStatus] = useState('active');

  const [payment, setPayment] = useState(null);
  const [selectedProjectId, setSelectedProjectId] = useState(null);

  // eslint-disable-next-line no-unused-vars
  const [createPermission, setCreatePermission] = React.useState(permitted(`PAYMENTRETURN_CREATE`));
  // eslint-disable-next-line no-unused-vars
  const [updatePermission, setUpdatePermission] = React.useState(permitted(`PAYMENTRETURN_UPDATE`));


  const [selectedReturn , setSelectedReturn] = React.useState({});


  const payreturn = useSelector(
    (state) => state.payreturn.payreturn
  );

  const payreturns = useSelector(
    (state) => state.payreturn.payreturns
  );

  const client = useSelector(
    (state) => state.lookup.client
  );

  const vendor = useSelector(
    (state) => state.lookup.vendor
  );


  const project = useSelector(
    (state) => state.lookup.project
  );


  const payments = useSelector(
    (state) => state.payment.payments
  );

  const costcenter = useSelector(
    (state) => state.costcenter.costcenter
  );



  const handleClose = (skipLoad) => {
    setShow(false);
    setSelectedReturn(null);
    setErrors({});

    if (!skipLoad) {
      load();
    }

    dispatch(resetPayReturn());
  }



  const handleShow = (selected) => {
    setShow(true);
    if (selected && selected.original.id) {
      // setSelectedTds(selected.original.id);
      dispatch(loadPayReturn(selected.original.id));

      dispatch(loadAllPayment(genPostData(selected.original)))

      loadPayment(selected.original.paymentid);

      setSelectedReturn(selected);
    }
    else {
      // setSelectedTds({});
      setField("date", format(new Date(), "yyyy-MM-dd"));
      setSelectedReturn(null);
    }
  }


  
  const genPostData = (selected, o_side )=>{

    const side =  o_side ? o_side :  selected.side

    let postData = {unallocated: true, execludeAuto: true, status:'closed'};

    if(costcenter && costcenter!=='0'){
      postData['costcenter']=costcenter;
    }

    postData['type'] = side === "CLIENT" ? "RECEIVED":"PAID"
    postData['projectid']= selectedProjectId;
    postData[`${side.toLowerCase()}id`] = side === "CLIENT" ? selected.clientid:  selected.vendorid;
      
    


    return postData;
  }





  const loadPayments = (projectId, side) => {

    if (projectId && projectId !== "0") {

      dispatch(loadAllPayment(genPostData(payreturn, side)))
    }
    else {
      dispatch(resetPayment());
    }

  }

  const loadPayment = (paymentId) => {

    if (paymentId) {
      loadPaymentService(paymentId)
        .then(res => {
          setPayment(res?.payment??{})
        })
        .catch(err => {
          setPayment(null);
          dispatch(notification(err));

        });

    }
    else {
      setPayment(null);
    }

  }

  const columns = React.useMemo(
    () => [

      {
        Header: 'Client',
        accessor: 'clientname',
        id: 'client'
      },
      {
        Header: 'Vendor',
        accessor: 'vendorname',
        id: 'vendor'
      },
      {
        Header: 'Project',
        accessor: 'projectname',
      },
      {
        Header: 'Date',
        accessor: (cell) => cell['date'] ? format(new Date(cell['date']), "dd-MM-yyyy") : "",
      },
      {
        Header: 'Payment Amount',
        accessor: (cell) => formatCurrency(cell['payment_gross']),
        className: 'text-end',
        hideFilter: true
      },
      {
        Header: 'Amount',
        accessor: (cell) => formatCurrency(cell['amount']),
        className: 'text-end',
        hideFilter: true
      }, {
        Header: 'Closed',
        accessor: (cell) => cell['closedDate'] ? format(new Date(cell['closedDate']), "dd-MM-yyyy") : "",
        show: status === 'active',
        id: 'closedDate'
      }],
    [status]
  )


  const load = () => {
    if (selectedProjectId) {

      dispatch(loadAllPayReturn({ status, projectid: selectedProjectId, costcenter }))
    }
    else {
      dispatch(loadAllPayReturn({ status, costcenter }))
    }
  }

  const setField = (field, value, idx) => {
    dispatch(changePayReturn({ name: field, value, idx }));

    // Check and see if errors exist, and remove them from the error object:
    if (!!errors[field]) setErrors({
      ...errors,
      [field]: null
    })
  }

  const handleSubmit = e => {

    e.preventDefault();
    // get our new errors
    const newErrors = findFormErrors()
    // Conditional logic:
    if (Object.keys(newErrors).length > 0) {
      setErrors(newErrors);
    } else {
      let dataToPost = {};
      let method = "POST";

      if (!payreturn.id) {
        dataToPost = {
          ...payreturn,
          type: 'RECEIVED'
        };
      }
      else {
        dataToPost = {
          ...payreturn
        };
        method = "PATCH";
      }

      savePayReturnService(dataToPost, method).then(res => {

        dispatch(notification(res));
        handleClose();
        dispatch(resetPayReturn());
      })
        .catch(err => {
          dispatch(notification(err))
        })

    }

  }

  const findFormErrors = () => {

    const { clientid, vendorid, side, projectid, date, amount, paymentid } = payreturn
    const newErrors = {}

    if (!date || date === '') newErrors.date = 'date cannot be blank!';

    if (side === "CLIENT" && (!clientid || clientid === "0")) newErrors.client = 'Select a client!'

    if (side === "VENDOR" && (!vendorid && vendorid !== 0)) newErrors.vendor = 'Select a vendor!'

    if (!projectid || projectid === "0") newErrors.project = 'Select a project!'

    if (!paymentid || paymentid === "0") newErrors.invoice = 'Select a payment!'

    if (!amount || amount === "") newErrors.amount = 'Amount cannot be blank!'

    return newErrors
  }


  React.useEffect(() => {
    load();
    handleClose(true);
    setSelectedProjectId(null);
    setPayment(null);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [status, costcenter]);

  React.useEffect(() => {
    dispatch(setEnableMobileMenu(false));
  }, [dispatch])

  
  const handleChange = (e) => { 

    const balance = (Number(payment?.gross ?? 0) + (Number(selectedReturn?.original?.amount ?? 0)) - Number(payment?.allocated ?? 0) ) - Number(payment?.return ?? 0) ;
    setErrors({...errors, amount:null});

    if (balance < Number(e.target.value)) {
     
      setErrors({...errors, amount:"Return amount should not be greater than invoice value"});
      // dispatch(warningNotification("Tax amount should not be greater than invoice gst value"))
    }

    else {
      setField("amount", e.target.value)
      
    }
  }



  const theme = useSelector((state) => state.ThemeOptions);


  return (
    <React.Fragment>
      {
        !show ? (

          <Container fluid >

            <Card>
              <Card.Header className={`${theme.headerBackgroundColor} d-flex`}>
                <h6 >Payment Return</h6>
                {createPermission ?
                  <div className="ms-auto">

                    {createPermission ? <Button variant="success" size="sm" onClick={() => handleShow()}> <i className="fa fa-plus d-md-none d-sm-inline"></i>
                      <p className="d-none d-md-inline">Add New</p></Button> : null}
                  </div> : null}
              </Card.Header>
              <Card.Body>
                <Row className="mb-3 g-2">
                  <Col sm={12} md={3} >

                    <Typeahead
                      id="floating-label-pro-filter"
                      onChange={(e) => {
                        setSelectedProjectId(e[0]?.id);
                      }}

                      clearButton
                      labelKey="name"
                      onBlur={() => {
                        if (!selectedProjectId) {
                          proTypeRef.current?.clear();
                        }
                      }}
                      options={filterProjectsSearch(project, costcenter)}

                      ref={proTypeRef}

                      placeholder="Choose s project"
                      renderInput={({ inputRef, referenceElementRef, ...inputProps }) => {
                        return (

                          <FloatingLabel controlId="floatingProjectFilter" label="Select a project">
                            <Form.Control
                              {...inputProps}
                              ref={(node) => {
                                inputRef(node);
                                referenceElementRef(node);
                              }}
                            />
                          </FloatingLabel>

                        );
                      }}
                      selected={selectedProjectId ? project.filter(e => e.id === Number(selectedProjectId)) : []}
                    />


                  </Col>


                  <Col>
                    {
                      !show ? (<div className="d-grid flex-fill d-md-flex gap-2  justify-content-md-end  h-100 align-items-end">


                        <Button variant="primary" size="sm" onClick={load}>Search</Button>
                      </div>) : ""}
                  </Col>
                </Row>
              </Card.Body>
            </Card>
            <RTable columns={columns} data={payreturns} title="Payment Return"
              // status={status}
              // changeStatus={setStatus} 
              hideColumn={status === 'active' ? ['closedDate'] : []}
              edit={handleShow} >



            </RTable>
          </Container>) : (
          <Container fluid >

            <Card>
              <Card.Header className={`${theme.headerBackgroundColor} d-flex`}>
                <h6>Payment Return</h6>
                <div className="ms-auto">

                  {((payreturn.id && updatePermission) || (!payreturn.id && createPermission)) ?
                    <Button variant="primary" size="sm" onClick={handleSubmit} title={payreturn.id ? "Update" : "Save"} className="me-2">
                      <i className="fa fa-save d-md-none d-sm-inline"></i>
                      <p className="d-none d-md-inline">  {payreturn.id ? "Update" : "Save"}</p></Button>
                    : null}
                  <Button variant="warning" size="sm" onClick={() => handleClose()} title="Back">
                    <i className="fa fa-arrow-left d-md-none d-sm-inline"></i>
                    <p className="d-none d-md-inline"> Back</p>
                  </Button>
                </div>
              </Card.Header>
              <Card.Body>

                <Row >

                  <Card className="col-sm-12 col-md-6 border-0 mb-0">
                    <Card.Body className="pt-0 pb-0">
                      <Col className="mb-3">
                        <FloatingLabel controlId="floatingTdsOn" label="Note On">
                          <Form.Select id="floatingTdsOn" isInvalid={!!errors.side} value={payreturn?.side ?? "0"}
                            onChange={e => {
                              setField("side", e.target.value);
                              setField("clientid", null);
                              setField("vendorid", null)
                              setField("projectid", null);
                              loadPayments("0");
                              setPayment(null);
                            }}
                          >

                            <option value="0">Select Note On</option>
                            <option value="CLIENT">Client</option>
                            <option value="VENDOR">Vendor</option>


                          </Form.Select>
                          <Form.Control.Feedback type='invalid'>{errors.side} </Form.Control.Feedback>
                        </FloatingLabel>
                      </Col>
                      {
                        !payreturn || !payreturn.side || payreturn.side === "0" ? null : (
                          <React.Fragment>
                            {

                              payreturn.side === 'CLIENT' ?
                                (<Col className="mb-3">


                                  <Typeahead
                                    id="floating-label-clt"
                                    onChange={(e) => {
                                      setField('clientid', e[0]?.id)
                                      setField('projectid', null)
                                    }}
                                    clearButton
                                    onBlur={() => {
                                      if (!payreturn.clientid) {
                                        cltEntryTypeRef.current?.clear();
                                        proEntryTypeRef.current?.clear();
                                        setField('projectid', null);
                                        setField('clientid')
                                      }
                                    }}
                                    labelKey="name"
                                    options={filterClient(client, costcenter)}
                                    ref={cltEntryTypeRef}
                                    placeholder="Choose a client"
                                    renderInput={({ inputRef, referenceElementRef, ...inputProps }) => {
                                      return (

                                        <FloatingLabel controlId="floatingClient" label="Select a client">
                                          <Form.Control
                                            isInvalid={!!errors.client}
                                            {...inputProps}
                                            ref={(node) => {
                                              inputRef(node);
                                              referenceElementRef(node);
                                            }}
                                          />
                                          <Form.Control.Feedback type='invalid'>{errors.client} </Form.Control.Feedback>
                                        </FloatingLabel>

                                      );
                                    }}
                                    selected={payreturn.clientid ? client.filter(e => e.id === Number(payreturn.clientid)) : []}
                                  />

                                </Col>)
                                : payreturn.side === 'VENDOR' ? (
                                  <Col className="mb-3">

                                    <Typeahead
                                      id="floating-label-ven"
                                      onChange={(e) => {
                                        setField('vendorid', e[0]?.id);
                                        setField("projectid", null);
                                        setPayment(null);
                                        loadPayments("0");
                                      }}
                                      clearButton
                                      onBlur={() => {
                                        if (!payreturn.vendorid) {
                                          venEntryTypeRef.current?.clear();
                                          proEntryTypeRef.current?.clear();
                                          loadPayments("0");
                                        }
                                      }}
                                      labelKey="name"
                                      options={vendor}
                                      ref={venEntryTypeRef}
                                      placeholder="Choose a vendor"
                                      renderInput={({ inputRef, referenceElementRef, ...inputProps }) => {
                                        return (

                                          <FloatingLabel controlId="floatingVendorId" label="Select a vendor">
                                            <Form.Control isInvalid={!!errors.mapping}
                                              {...inputProps}
                                              ref={(node) => {
                                                inputRef(node);
                                                referenceElementRef(node);
                                              }}
                                            />
                                            <Form.Control.Feedback type='invalid'>{errors.vendor} </Form.Control.Feedback>
                                          </FloatingLabel>

                                        );
                                      }}
                                      selected={payreturn.vendorid || payreturn.vendorid === 0 ? vendor.filter(e => e.id === Number(payreturn.vendorid)) : []}
                                    />

                                  </Col>) : null


                            }
                            <Col className="mb-3">
                              <Typeahead
                                id="floating-label-pro"
                                onChange={(e) => {
                                  setField('projectid', e[0]?.id)
                                  if (e[0] && e[0].id) {
                                    setPayment(null);
                                    loadPayments(e[0].id, payreturn.side);
                                  }
                                  else {
                                    dispatch(resetPayment());
                                  }
                                }}
                                clearButton
                                labelKey="name"
                                onBlur={() => {
                                  if (!payreturn.projectid) {
                                    proEntryTypeRef.current?.clear();
                                    dispatch(resetPayment());
                                  }
                                }}
                                options={project && ((payreturn.clientid && payreturn.clientid !== "0") || payreturn.side === 'VENDOR') ?
                                  filterProjects(project, costcenter).filter(e => Number(e.clientid) === Number(payreturn.clientid) || payreturn.side === 'VENDOR') : []}

                                ref={proEntryTypeRef}

                                placeholder="Choose A Project"
                                renderInput={({ inputRef, referenceElementRef, ...inputProps }) => {
                                  return (

                                    <FloatingLabel controlId="floatingProject" label="Select A Project">
                                      <Form.Control isInvalid={!!errors.project}
                                        {...inputProps}
                                        ref={(node) => {
                                          inputRef(node);
                                          referenceElementRef(node);
                                        }}
                                      />
                                      <Form.Control.Feedback type='invalid'>{errors.project} </Form.Control.Feedback>
                                    </FloatingLabel>

                                  );
                                }}
                                selected={payreturn.projectid ? project.filter(e => e.id === Number(payreturn.projectid)) : []}
                              />



                            </Col>
                          </React.Fragment>


                        )}
                      <Col className="mb-3">
                        <FloatingLabel controlId="floatingPayment" label="Payment">
                          <Form.Select id="floatingPayment" aria-label="Payment" isInvalid={!!errors.payment}
                            value={payreturn?.paymentid ?? "0"}
                            onChange={e => {
                              setField("paymentid", e.target.value)
                              setPayment(null);
                              if(e.target.value && e.target.value!=="0"){
                                loadPayment(e.target.value);
                              }
                            }}
                          >
                            <option value="0">Select a Payment</option>
                            {
                              payments ? payments.map((e, i) => {
                                return <option key={`inv${i}`} value={e.id} >{e.paiddate}-{e.gross}</option>
                              }) : null
                            }

                          </Form.Select>
                          <Form.Control.Feedback type='invalid'>{errors.payment} </Form.Control.Feedback>
                        </FloatingLabel>
                      </Col>



                    </Card.Body>

                  </Card>
                  <Card className="col-sm-12 col-md-6 border-0">
                    <Card.Body className="pt-0 pb-0" >
                      {payment ? <Col className="mb-3">
                        <Row className="g-2">
                          <Col sm={6} >
                            <FloatingLabel controlId="floatingGross" label="Gross" >
                              <Form.Control type="text"  placeholder="Gross" value={payment?.gross ?? "0"} readOnly="true"/>
                              
                            </FloatingLabel>
                          </Col>
                          <Col sm={6} >
                            <FloatingLabel controlId="floatingAllocated" label="Allocated" >
                              <Form.Control type="text" placeholder="Allocated" value={payment?.allocated ?? "0"}  readOnly="true"/>
                            </FloatingLabel>
                          </Col>

                          <Col sm={6} >
                            <FloatingLabel controlId="floatingBalance" label="Balance" >
                              <Form.Control type="text"  placeholder="Balance" value={(payment?.gross ?? 0) -(payment?.allocated ?? 0)} readOnly="true"/>
                              
                            </FloatingLabel>
                          </Col>
                      
                        </Row>
                      </Col> : null}
                      

                      <Col className="mb-3">

                        <div style={{ position: "relative" }} className="dp">
                          <DatePicker maxDate={new Date()}
                            minDate={minDate ? new Date(minDate) : null}
                            id="tdsDate"
                            format="dd-MM-yyyy"
                            calendarIcon={<i className="fa fa-calendar"></i>}
                            clearIcon = {null}
                            className={`form-control ${!!errors.date ? "is-invalid" : ""}`}
                            //isInvalid={true}
                            value={payreturn.date ? new Date(payreturn.date) : ""}
                            onChange={(date) => setField("date", format(date, "yyyy-MM-dd"))}  

                          ></DatePicker>
                          <label className="black-text" htmlFor="tdsDate"> Date</label>
                        </div>

                      </Col>


                      <Col className="mb-3">
                        <FloatingLabel controlId="floatingAmount" label="Amount">
                          <Form.Control type="text" placeholder="Amount" isInvalid={!!errors.amount} 
                            value={payreturn.amount ?? ""} 
                            onChange={e => handleChange(e)} />
                          <Form.Control.Feedback type='invalid'>{errors.amount} 
                          </Form.Control.Feedback>
                        </FloatingLabel>
                      </Col>



                    </Card.Body>
                  </Card>
                </Row>
              </Card.Body>
            </Card>
          </Container>)
      }
      {/* <Confirm show={showConfirm} confirmation="Are you sure?" confirmCallBack={deletePayRequestOrder}></Confirm> */}
    </React.Fragment >);
}

// }
